import { Entity } from './entity';
import { attributesFromSchema } from './attributesFromSchema';
export function entityFromSchema(schema) {
    const { attributes, attributesContainerSchema, attributesContainerSchemaLocation } = attributesFromSchema(schema);
    const entity = new Entity(schema, attributes, attributesContainerSchema, attributesContainerSchemaLocation);
    return entity;
}
